import { render, staticRenderFns } from "./personalResume.vue?vue&type=template&id=ac3ffb3a&scoped=true&"
import script from "./personalResume.vue?vue&type=script&lang=js&"
export * from "./personalResume.vue?vue&type=script&lang=js&"
import style0 from "./personalResume.vue?vue&type=style&index=0&id=ac3ffb3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3ffb3a",
  null
  
)

export default component.exports